module.exports = __webpack_public_path__ + "img/info4.5d8440e3.png";